// extracted by mini-css-extract-plugin
export default {"test":"TestStyles_test__mJhWs"};